interface Props {
  /** Prominent one-liner from the analyzer (`SentimentResponse.sentiment_summary`). */
  summary?: string | null;
  /** Secondary detail (`SentimentResponse.confidence_explanation`). */
  confidenceExplanation?: string | null;
  /** Secondary detail (`SentimentResponse.contribution_explanation`). */
  contributionExplanation?: string | null;
}

/**
 * Surfaces the analyzer's explanatory text that the page otherwise hides.
 * Each field is gated independently — renders nothing if all are absent.
 * Inner content only; lives directly under the SentimentBar in the same section.
 */
export default function SentimentNarrative({
  summary,
  confidenceExplanation,
  contributionExplanation,
}: Props) {
  const hasDetail = !!confidenceExplanation || !!contributionExplanation;
  if (!summary && !hasDetail) return null;

  return (
    <div className="POST__ANALYSIS__narrative">
      {summary && (
        <p className="POST__ANALYSIS__narrative__summary">{summary}</p>
      )}
      {hasDetail && (
        <dl className="POST__ANALYSIS__narrative__detail">
          {confidenceExplanation && (
            <div>
              <dt>Confidence</dt>
              <dd>{confidenceExplanation}</dd>
            </div>
          )}
          {contributionExplanation && (
            <div>
              <dt>Contribution</dt>
              <dd>{contributionExplanation}</dd>
            </div>
          )}
        </dl>
      )}
    </div>
  );
}
